// extracted by mini-css-extract-plugin
export default {"toast":"styles_toast__S+0ya","content":"styles_content__Ff0w0","message":"styles_message__3a89W","close":"styles_close__7n1GS","bone-skeleton":"styles_bone-skeleton__l-BKZ"};